import React from 'react';

export const CARD_BG = '#0f1923';

export function Section({ title, children }) {
  return (
    <div style={{ background: CARD_BG, borderRadius: 12, padding: 24, marginBottom: 20, border: '1px solid #1e293b' }}>
      <h3 style={{ color: '#e2e8f0', fontSize: '1rem', fontWeight: 600, margin: '0 0 12px 0' }}>{title}</h3>
      <div style={{ color: '#cbd5e1', fontSize: 13, lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

export function TermsSection({ num, title, children }) {
  return (
    <div style={{ background: CARD_BG, borderRadius: 12, padding: 24, marginBottom: 16, border: '1px solid #1e293b' }}>
      <h3 style={{ color: '#e2e8f0', fontSize: '1rem', fontWeight: 600, margin: '0 0 10px 0' }}>
        {num}. {title}
      </h3>
      <div style={{ color: '#cbd5e1', fontSize: 13, lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

export function CodeBlock({ children }) {
  return (
    <pre style={{
      background: '#0a1120', border: '1px solid #1e293b', borderRadius: 8,
      padding: '12px 16px', color: '#94a3b8', fontSize: 12, lineHeight: 1.6,
      overflowX: 'auto', margin: '12px 0',
    }}>
      {children}
    </pre>
  );
}
